import { AddressCard } from "@totalenergiescode/mobility-business-rev-design-system";
import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";

interface EditableCardSummaryProps {
  fieldId: string;
  nameLabelTranslation: string;
  addressLabelTranslation: string;
}

function EditableCardSummary({
  fieldId,
  nameLabelTranslation,
  addressLabelTranslation,
}: Readonly<EditableCardSummaryProps>) {
  const { dataTestIdPrefix, findFieldById, findCompositeFieldByName } =
    useFormDataContext();

  const field = findFieldById(fieldId);
  const nameValue = field.value.asString();

  const companyNameValue = findCompositeFieldByName(
    field,
    "companyName",
  ).value.asString();
  const addressValue = findCompositeFieldByName(
    field,
    "address",
  ).value.asString();
  const locationValue = findCompositeFieldByName(
    field,
    "location",
  ).value.asString();
  const cityValue = findCompositeFieldByName(field, "city").value.asString();
  const zipCodeValue = findCompositeFieldByName(
    field,
    "zipCode",
  ).value.asString();
  const countryValue = findCompositeFieldByName(
    field,
    "country",
  ).value.asString();

  return (
    <AddressCard
      nameLabel={nameLabelTranslation}
      addressLabel={addressLabelTranslation}
      address={{
        name: nameValue.value() || nameValue.defaultValue(),
        companyName:
          companyNameValue.value() || companyNameValue.defaultValue(),
        address: addressValue.value() || addressValue.defaultValue(),
        location: locationValue.value() || locationValue.defaultValue(),
        city: cityValue.value() || cityValue.defaultValue(),
        zipCode: zipCodeValue.value() || zipCodeValue.defaultValue(),
        country: countryValue.value() || countryValue.defaultValue(),
      }}
      isEditable={false}
      dataTestId={`${dataTestIdPrefix}-editable-card-summary`}
    />
  );
}

export default EditableCardSummary;
